import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IDayOfWeek } from './IDayOfWeek';

@Injectable({
    providedIn: 'root'
})
export class DaysOfWeekService {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}
    uri = `${environment.apiLocation}/eFDayOfWeek`;
    public get(): Observable<Array<IDayOfWeek>> {

        this.log.verbose({
            type: 'DaysOfWeekService:get',
            uri: this.uri,
        });
        return this.http.get<Array<IDayOfWeek>>(this.uri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'DaysOfWeekService:reponse',
                    res
                })
            )
        );
    }
}
